import { Column } from "components/kanbanBoard/types.ts";
import { TaskPhase } from "shared/types/task";

export const KANBAN_COLUMNS: Column[] = [
  {
    id: TaskPhase.TODAY,
    title: "Vandaag",
  },
  {
    id: TaskPhase.TOMORROW,
    title: "Morgen",
  },
  {
    id: TaskPhase.THIS_WEEK,
    title: "Deze week",
  },
  {
    id: TaskPhase.NEXT_WEEK,
    title: "Volgende week",
  },
  {
    id: TaskPhase.LATER,
    title: "Later",
  },
  {
    id: TaskPhase.REVIEW,
    title: "Review",
  },
  {
    id: TaskPhase.VALIDATED,
    title: "Gevalideerd",
  },
  {
    id: TaskPhase.REMARKS,
    title: "Bemerkingen",
  },
];

export enum ContactSubCategory {
  AcademischeInstelling = "Academische instelling",
  MediaCommunicatie = "Media & Communicatie",
  Journalist = "Journalist",
  //Media = "Media",
  GroothandelProducten = "Groothandel producten",
  ConsultantMarketingCommunicatie = "Consultant - Marketing en communicatie",
  Notaris = "Notaris",
  Advocaat = "Advocaat",
  ConsultantFinancieel = "Consultant - Financieel",
  Bank = "Bank",
  MakelaarVerzekeringen = "Makelaar - Verzekeringen",
  Verzekeringsmaatschappij = "Verzekeringsmaatschappij",
  Overheid = "Overheid",
  Nutsvoorzieningen = "Nutsvoorzieningen",
  Landmeter = "Landmeter",
  Architect = "Architect",
  Vastgoedbeheerder = "Vastgoedbeheerder",
  ConsultantEnergie = "Consultant - Energie",
  AdviesenIngenieursbureau = "Advies- en ingenieursbureau",
  MakelaarVastgoed = "Makelaar - Vastgoed",
  ConsultantVastgoed = "Consultant - Vastgoed",
  MakelaarBedrijven = "Makelaar - bedrijven",
  AannemerSanitairEnVerwarming = "Aannemer - Sanitair en verwarming",
  AannemerElectro = "Aannemer - Electro",
  AannemerTotaal = "Aannemer - Totaal",
  AannemerRuwbouw = "Aannemer - Ruwbouw",
  AannemerDakwerken = "Aannemer - Dakwerken",
  AannemerAfbraakEnGrondwerken = "Aannemer - Afbraak en grondwerken",
  AannemerAfwerking = "Aannemer - Afwerking",
  LeverancierBouw = "Leverancier - Bouw",
  ConsultantBouw = "Consultant - Bouw",
  Interieur = "Interieur",
  Onderhoud = "Onderhoud",
  OnderhoudKeuring = "Onderhoud - Keuring",
  Leverancier = "Leverancier",
  Projectontwikkelaar = "Projectontwikkelaar",
  Development = "Development",
  Freelancers = "Freelancers",
  ConsultantIT = "Consultant - IT",
  ConsultantHRM = "Consultant - HRM",
  Huurder = "Huurder",
  ExHuurder = "Ex-huurder",
  Retail = "Retail",
  Horeca = "Horeca",
  InvesteerderInstitutioneel = "Investeerder - Institutioneel",
  InvesteerderPrive = "Investeerder - Privé",
  //Holding = "Holding",
  Eigenaar = "Eigenaar",
  EigenaarRetail = "Eigenaar retail",
  EigenaarResidentieelVastgoed = "Eigenaar Residentieel Vastgoed",
  BinnenstedelijkCommercieelVastgoed = "Binnenstedelijk Commercieel Vastgoed",
}

export enum ContactsMainCategory {
  "Acquisitie en eigenaars" = "Acquisitie en eigenaars",
  "Educatie & Onderzoek" = "Educatie & Onderzoek",
  "Financieel & verzekeringen" = "Financieel & verzekeringen",
  "HRM" = "HRM",
  "IT" = "IT",
  "Juridisch" = "Juridisch",
  "Makelaars" = "Makelaars",
  "Media & Communicatie" = "Media & Communicatie",
  "Overheid & Openbare Diensten" = "Overheid & Openbare Diensten",
  "Renovatie & onderhoud" = "Renovatie & onderhoud",
  "Technische adviseurs" = "Technische adviseurs",
  "Verhuur" = "Verhuur",
  "Interieur" = "Interieur",
}

const ContactCategorySubCategoryMap = {
  [ContactsMainCategory["Acquisitie en eigenaars"]]: [
    { InvesteerderInstitutioneel: "Investeerder - Institutioneel" },
    { InvesteerderPrive: "Investeerder - Privé" },
    { Holding: "Holding" },
    { Eigenaar: "Eigenaar" },
    { EigenaarRetail: "Eigenaar retail" },
    { EigenaarResidentieelVastgoed: "Eigenaar Residentieel Vastgoed" },
    {
      BinnenstedelijkCommercieelVastgoed:
        "Binnenstedelijk Commercieel Vastgoed",
    },
  ],
  [ContactsMainCategory["Educatie & Onderzoek"]]: [
    { AcademischeInstelling: "Academische instelling" },
  ],
  [ContactsMainCategory["Financieel & verzekeringen"]]: [
    { ConsultantFinancieel: "Consultant - Financieel" },
    { Bank: "Bank" },
    { MakelaarVerzekeringen: "Makelaar - Verzekeringen" },
    { Verzekeringsmaatschappij: "Verzekeringsmaatschappij" },
  ],
  [ContactsMainCategory.HRM]: [{ ConsultantHRM: "Consultant - HRM" }],
  [ContactsMainCategory.IT]: [
    { Development: "Development" },
    { Freelancers: "Freelancers" },
    { ConsultantIT: "Consultant - IT" },
  ],
  [ContactsMainCategory.Juridisch]: [
    { Notaris: "Notaris" },
    { Advocaat: "Advocaat" },
  ],
  [ContactsMainCategory.Makelaars]: [
    { MakelaarVastgoed: "Makelaar - Vastgoed" },
    { ConsultantVastgoed: "Consultant - Vastgoed" },
    { MakelaarBedrijven: "Makelaar - bedrijven" },
  ],
  [ContactsMainCategory["Media & Communicatie"]]: [
    { Journalist: "Journalist" },
    { Media: "Media" },
    {
      ConsultantMarketingCommunicatie: "Consultant - Marketing en communicatie",
    },
  ],
  [ContactsMainCategory["Overheid & Openbare Diensten"]]: [
    { Overheid: "Overheid" },
    { Nutsvoorzieningen: "Nutsvoorzieningen" },
  ],
  [ContactsMainCategory["Renovatie & onderhoud"]]: [
    { AannemerSanitairEnVerwarming: "Aannemer - Sanitair en verwarming" },
    { AannemerElectro: "Aannemer - Electro" },
    { AannemerTotaal: "Aannemer - Totaal" },
    { AannemerRuwbouw: "Aannemer - Ruwbouw" },
    { AannemerDakwerken: "Aannemer - Dakwerken" },
    { AannemerAfbraakEnGrondwerken: "Aannemer - Afbraak en grondwerken" },
    { LeverancierBouw: "Leverancier - Bouw" },
    { ConsultantBouw: "Consultant - Bouw" },
  ],
  [ContactsMainCategory["Technische adviseurs"]]: [
    { Landmeter: "Landmeter" },
    { Architect: "Architect" },
    { Vastgoedbeheerder: "Vastgoedbeheerder" },
    { ConsultantEnergie: "Consultant - Energie" },
    { AdviesenIngenieursbureau: "Advies- en ingenieursbureau" },
  ],
  [ContactsMainCategory.Interieur]: [
    { Onderhoud: "Onderhoud" },
    { OnderhoudKeuring: "Onderhoud - Keuring" },
    { Leverancier: "Leverancier" },
    { Projectontwikkelaar: "Projectontwikkelaar" },
  ],
  [ContactsMainCategory.Verhuur]: [
    { Huurder: "Huurder" },
    { ExHuurder: "Ex-huurder" },
    { Retail: "Retail" },
    { Horeca: "Horeca" },
  ],
};

export const CONTACT_CATEGORY_SUBCATEGORY_MAP = Object.entries(
  ContactCategorySubCategoryMap,
).map(([key, value]) => ({ key, value }));
export const MAIN_CATEGORIES = Object.keys(ContactsMainCategory);
export const SUB_CATEGORIES_KEYS = Object.keys(ContactSubCategory);
export const SUB_CATEGORIES = Object.entries(ContactSubCategory).map(
  ([key, value]) => ({ key, value }),
);
